import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { CustomValidatorService } from '../../../service/custom-validator.service';
import { AuthenticationService } from '../../../service/system/authentication.service';
import { ToolService } from '../../../service/tool.service';

@Component({
  selector: 'app-tool-detail',
  templateUrl: './tool-detail.component.html',
  styleUrls: ['./tool-detail.component.less']
})
export class ToolDetailComponent implements OnInit {

  @Input() operateToolFlag: string;
  @Input() currentTool: any;
  validateForm: FormGroup;
  userInfo: any;
  toolType = [];
  toolStatus = [];
  isModifyDetail = false;
  // notModify = true;
  isReset = false;
  isNotModify = false;
  isCheckFormChanged = true;
  originalStatus: string;

  constructor(private fb: FormBuilder,
    private customValidatorService: CustomValidatorService,
    private toolService: ToolService,
    public message: NzMessageService,
    private modal: NzModalRef,
    private authService: AuthenticationService, ) { }

  ngOnInit(): void {
    this.validateForm = this.fb.group({
      toolName: new FormControl({ value: '', disabled: true }, Validators.minLength(1)),
      toolType: new FormControl({ value: '1', disabled: true }, Validators.required),
      toolUser: new FormControl({ value: '', disabled: true }, Validators.minLength(1)),
      toolBuyTime: new FormControl({ value: '', disabled: true }),
      toolCount: new FormControl({ value: '', disabled: true }, [Validators.required, this.customValidatorService.numberValidator]),
      // tslint:disable-next-line:max-line-length
      userPhoneNumber: new FormControl({ value: '', disabled: true }, [Validators.required, this.customValidatorService.tellPhoneNumberValidator]),
      toolModel: new FormControl({ value: '', disabled: true }, Validators.minLength(0)),
      toolUnit: new FormControl({ value: '', disabled: true }, Validators.minLength(0)),
      toolStatus: new FormControl({ value: '', disabled: false }, Validators.minLength(0)),
      toolTrack: new FormControl({ value: '', disabled: false }, []),
      toolDescription: new FormControl({ value: '', disabled: true }, Validators.minLength(0))
    });
    this.getToolType();
    this.getToolStatus();
    this.userInfo = this.authService.getCurrentUserInfo();
    // '0'表示新建工具
    if (this.operateToolFlag === '0') {
      this.validateForm.enable();
    }
    // '1'表示修改工具
    if (this.operateToolFlag === '1') {
      this.originalStatus = this.currentTool.status;
      this.isModifyDetail = true;
      this.validateForm.get('toolName').setValue(!this.isEmpty(this.currentTool.tname) ? this.currentTool.tname : '');
      this.validateForm.get('toolType').setValue(!this.isEmpty(this.currentTool.ttNo) ? this.currentTool.ttNo : '');
      this.validateForm.get('toolUser').setValue(!this.isEmpty(this.currentTool.toolUser) ? this.currentTool.toolUser : '');
      // tslint:disable-next-line:max-line-length
      this.validateForm.get('toolBuyTime').setValue(!this.isEmpty(this.currentTool.boughtTime) ? new Date(this.currentTool.boughtTime) : null);
      this.validateForm.get('toolCount').setValue(!this.isEmpty(this.currentTool.amount) ? this.currentTool.amount : '');
      this.validateForm.get('userPhoneNumber').setValue(!this.isEmpty(this.currentTool.phone) ? this.currentTool.phone : '');
      this.validateForm.get('toolModel').setValue(!this.isEmpty(this.currentTool.spec) ? this.currentTool.spec : '');
      this.validateForm.get('toolUnit').setValue(!this.isEmpty(this.currentTool.unit) ? this.currentTool.unit : '');
      this.validateForm.get('toolStatus').setValue(!this.isEmpty(this.currentTool.status) ? this.currentTool.status : '');
      this.validateForm.get('toolDescription').setValue(!this.isEmpty(this.currentTool.toolDesc) ? this.currentTool.toolDesc : '');
      this.validateForm.get('toolTrack').setValue(!this.isEmpty(this.currentTool.record) ? this.currentTool.record : '');
    }
  }

  async submitFormData() {
    if (this.validateForm.value.toolUnit !== undefined && this.validateForm.value.toolUnit !== null
      && this.validateForm.value.toolUnit.length > 4) {
      this.message.create('warning', '工具单位长度不能超过4!');
      return;
    }
    if (this.operateToolFlag === '1') {
      if (this.originalStatus !== this.validateForm.value.toolStatus &&
        (this.validateForm.value.toolTrack === undefined || this.validateForm.value.toolTrack == null ||
          this.validateForm.value.toolTrack.length === 0)) {
        this.message.create('warning', '请输入变动记录!');
        return;
      }
    }

    this.validateForm.enable();
    try {
      this.validateForm.setValue({
        toolName: this.validateForm.value.toolName,
        toolType: this.validateForm.value.toolType,
        toolUser: this.validateForm.value.toolUser,
        toolBuyTime: this.validateForm.value.toolBuyTime,
        toolCount: this.validateForm.value.toolCount,
        userPhoneNumber: this.validateForm.value.userPhoneNumber,
        toolModel: this.validateForm.value.toolModel,
        toolUnit: this.validateForm.value.toolUnit,
        toolStatus: this.validateForm.value.toolStatus,
        toolTrack: this.validateForm.value.toolTrack,
        toolDescription: this.validateForm.value.toolDescription,
      });
    } catch (error) {
      // this.message.create('error', '请填写必填项!');
    }
    // tslint:disable-next-line:max-line-length
    if (this.operateToolFlag === '0' && !this.isEmpty(this.validateForm.value.toolName) && !this.isEmpty(this.validateForm.value.toolType) && !this.isEmpty(this.validateForm.value.toolUser) && !this.isEmpty(this.validateForm.value.toolCount)) {
      const result: any = await this.toolService.addTool({
        tname: this.validateForm.value.toolName,
        ttNo: this.validateForm.value.toolType,
        toolUser: this.validateForm.value.toolUser,
        boughtTime: this.validateForm.value.toolBuyTime,
        amount: this.validateForm.value.toolCount,
        phone: this.validateForm.value.userPhoneNumber,
        spec: this.validateForm.value.toolModel,
        unit: this.validateForm.value.toolUnit,
        status: this.validateForm.value.toolStatus,
        record: this.validateForm.value.toolTrack,
        toolDesc: this.validateForm.value.toolDescription,
        createBy: this.userInfo.userId,
      });
      if (result.code === 200) {
        this.message.create('success', '创建工具成功!');
        this.modal.destroy();
      } else {
        this.message.create('error', '创建工具失败!');
      }
    } else if (this.operateToolFlag === '1' && this.checkFormChanged()) {
      // alert('正在修改工具');
      this.toolService.updateTool({
        tno: this.currentTool.tno,
        tname: this.validateForm.value.toolName,
        ttNo: this.validateForm.value.toolType,
        toolUser: this.validateForm.value.toolUser,
        boughtTime: this.validateForm.value.toolBuyTime,
        amount: this.validateForm.value.toolCount,
        phone: this.validateForm.value.userPhoneNumber,
        spec: this.validateForm.value.toolModel,
        unit: this.validateForm.value.toolUnit,
        status: this.validateForm.value.toolStatus,
        record: this.validateForm.value.toolTrack,
        toolDesc: this.validateForm.value.toolDescription,
        updateBy: this.userInfo.userId,
      }).subscribe((res) => {
        if (res === 200) {
          this.message.create('success', '工具修改成功!');
          this.modal.destroy();
        } else {
          this.message.error('工具修改失败');
        }
      }, err => {
        this.message.error('工具修改失败: ' + err.msg);
      });
    } else {
      if (this.isReset) {
        this.message.create('success', '表单已重置!');
        this.isReset = false;
      } else if (this.isNotModify) {
        this.message.create('success', '表单已激活!');
        this.isNotModify = false;
      } else if (!this.isCheckFormChanged) {
        this.message.create('error', '修改失败，请修改工具详情后再提交修改!');
        // this.isCheckFormChanged = true;
      } else {
        this.message.create('error', '操作失败，请检查是否有项目遗漏!');
      }
    }
  }

  resetForm() {
    this.validateForm.reset();
    this.isReset = true;
  }

  activeForm() {
    this.isNotModify = true;
    this.validateForm.enable();
  }

  okForm() {
    this.modal.destroy();
  }

  getToolType() {
    this.toolService.getToolTypeList().subscribe((response: any) => {
      if (response.code === 200) {
        this.toolType = response.data;
      }
    });
  }

  getToolStatus() {
    this.toolService.getToolStatusList().subscribe((response: any) => {
      if (response.code === 200) {
        this.toolStatus = response.data;
      }
    });
  }
  checkFormChanged() {
    if (
      this.validateForm.value.toolType === this.currentTool.ttNo.toString() &&
      this.validateForm.value.toolStatus === this.currentTool.status &&
      this.validateForm.value.toolName === this.currentTool.tname &&
      this.validateForm.value.toolModel === this.currentTool.spec &&
      this.validateForm.value.toolCount === this.currentTool.amount &&
      this.validateForm.value.toolUnit === this.currentTool.unit &&
      this.validateForm.value.toolUser === this.currentTool.toolUser &&
      this.validateForm.value.userPhoneNumber === this.currentTool.phone &&
      this.validateForm.value.toolDescription === this.currentTool.toolDesc &&
      this.validateForm.value.toolBuyTime.toString() === new Date(this.currentTool.boughtTime).toString()
    ) {
      this.isCheckFormChanged = false;
      return false;
    } else {
      this.isCheckFormChanged = true;
      return true;
    }
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
